export default {
  filterDropdownsWrapper: {
    display: 'inline-flex',
    m: '0 16px'
  }
};